import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import StyledButton from '../Common/StyledButton';
import { CLIENTS_ROUTE } from '../../utils/routes';
import { getPlanInfo } from '../../utils/paymentUtills';
import { SubscriptionPlanTypes } from '../../types/coach';

export default function PaymentInfo({
  plan,
  dismiss,
}: {
  plan: SubscriptionPlanTypes | null;
  dismiss: () => void;
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();

  let text1: string = '';
  let text2: string = '';

  if (plan) {
    const texts = getPlanInfo(plan);
    text1 = texts?.text1;
    text2 = texts?.text2;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={location.pathname === CLIENTS_ROUTE ? 4 : 7}
      justifyContent="center"
      alignItems="center"
      mt={isSmallScreen ? 4 : 0}
      maxWidth={428}
      marginX="auto"
      paddingY={4.1}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <Typography variant="bodyBold" textAlign="center">
            {t('payment.subscriptionInfo')}
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
          <Typography variant="bodyRegular">{text1}</Typography>
          <Typography variant="bodyRegular">{text2}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <Typography variant="bodyBold">{t('payment.paymentProcessingStripe')}</Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="bodyRegular">{t('payment.paymentProcessingStripeDesc')}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <Typography variant="bodyBold">{t('payment.privacyMessage')}</Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="bodyRegular">{t('payment.privacyMessageDesc')}</Typography>
        </Box>
      </Box>
      <StyledButton paddingY={12} paddingX={56} onClick={() => dismiss()}>
        {t('common.dismiss')}
      </StyledButton>
    </Box>
  );
}
